(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["country-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    document.addEventListener('click', function (e) {
      document.querySelectorAll('details[data-country-selector][open]').forEach(function (el) {
        if (!el.contains(e.target)) el.removeAttribute('open');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('details[data-country-selector][open]').forEach(function (el) {
        el.removeAttribute('open');
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-nav"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-mnav]');
    if (!root) return;
    var panels = root.querySelectorAll('[data-mnav-panel]');
    function show(id) {
      panels.forEach(function (p) {
        var active = p.getAttribute('data-mnav-panel') === id;
        // Tailwind v4 `translate-x-full` sets the CSS `translate` property, so
        // drive that same property here (setting `transform` would not override it).
        p.style.translate = active ? '0%' : '100%';
      });
      root.setAttribute('data-panel', id);
    }
    root.addEventListener('click', function (e) {
      var go = e.target.closest('[data-mnav-go]');
      if (go) { show(go.getAttribute('data-mnav-go')); return; }
      // Search / cart: close this drawer, then open the requested one.
      var drawerBtn = e.target.closest('[data-mnav-drawer]');
      if (drawerBtn && window.AzhaDrawer) {
        window.AzhaDrawer.close('mobile-nav');
        window.AzhaDrawer.open(drawerBtn.getAttribute('data-mnav-drawer'));
      }
    });
    // Reset to root whenever the drawer closes.
    document.addEventListener('drawer:close', function () { show('root'); });
  })();
  } catch(e) { console.error(e); }
})();

})();
